import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAllAcademicRecognitionUniStatuses } from "../../../../axios/api/services";
import {
  fulfilledThunkState,
  initialThunkState,
  pendingThunkState,
  rejectedThunkState,
  commonThunkCondition,
} from "@duosoftbg/nacid-components";

const sliceName = "appData/arUniStatuses";
const arUniStatusesSlice = createSlice({
  name: sliceName,
  initialState: initialThunkState([]),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(arUniStatusesThunk.pending, (state, action) => {
      return pendingThunkState(state);
    });
    builder.addCase(arUniStatusesThunk.fulfilled, (state, action) => {
      const { data } = action.payload;
      return fulfilledThunkState(data);
    });
    builder.addCase(arUniStatusesThunk.rejected, (state, action) => {
      return rejectedThunkState([]);
    });
  },
});

export const arUniStatusesThunk = createAsyncThunk(
  `${sliceName}/arUniStatusesThunk`,
  async () => {
    const response = await getAllAcademicRecognitionUniStatuses()();
    return { data: response };
  },
  {
    condition: (_, { getState, extra }) => {
      return commonThunkCondition(getState()["AppData"]?.arUniStatuses);
    },
  },
);

export default arUniStatusesSlice.reducer;
